// src/auth/CambiarContrasena.jsx
// Cambio de contraseña obligatorio (DebeCambiarContrasena). Mientras esté pendiente,
// el usuario solo puede estar en esta pantalla; la API rechaza las demás rutas.
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { changeOwnPassword, logout } from './authService';
import { getToken } from '../services/api';

import './Login.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const MIN_PASSWORD = 10;

export default function CambiarContrasena() {
  const navigate = useNavigate();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  if (!getToken()) return <Navigate to="/login" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setErr('');
    if (!actual || !nueva || !confirmar) return setErr('Completa todos los campos.');
    if (nueva.length < MIN_PASSWORD) return setErr(`La contraseña nueva debe tener al menos ${MIN_PASSWORD} caracteres.`);
    if (nueva !== confirmar) return setErr('Las contraseñas nuevas no coinciden.');
    if (nueva === actual) return setErr('La contraseña nueva debe ser distinta de la actual.');
    try {
      setBusy(true);
      await changeOwnPassword(actual, nueva);
      navigate('/Finanzas', { replace: true });
    } catch (e) {
      setErr(e instanceof TypeError ? 'Fallo de red. Revisa tu conexión.' : (e?.message || 'No se pudo cambiar la contraseña.'));
    } finally {
      setBusy(false);
    }
  };

  const salir = () => { logout(); navigate('/login', { replace: true }); };
  const tipo = mostrar ? 'text' : 'password';

  return (
    <div className="login-shell">
      <div className="login-frame">
        <aside className="hero">
          <div className="hero-inner">
            <div className="hero-badge">
              <img src="/img/que-taco.jpg" alt="Que Taco" className="brand-logo"/>
            </div>
            <div className="hero-brand">Que Taco</div>
            <h1 className="hero-title">Sistema de Finanzas</h1>
          </div>
          <div className="hero-pattern" aria-hidden />
        </aside>

        <main className="form-area">
          <div className="form-card">
            <h2 className="form-title">Cambia tu contraseña</h2>
            <p className="small text-muted mb-3">
              Por seguridad debes definir una contraseña nueva antes de continuar. Usa al menos {MIN_PASSWORD} caracteres;
              puedes combinar letras, números y símbolos.
            </p>

            {err && <div className="alert alert-danger py-2 small mb-3" role="alert">{err}</div>}

            <form onSubmit={onSubmit} noValidate>
              <div className="mb-3">
                <label className="form-label" htmlFor="actualInput">Contraseña actual</label>
                <input id="actualInput" type={tipo} className="form-control" value={actual}
                  onChange={(e) => setActual(e.target.value)} autoComplete="current-password" required disabled={busy} />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="nuevaInput">Contraseña nueva</label>
                <input id="nuevaInput" type={tipo} className="form-control" value={nueva} minLength={MIN_PASSWORD}
                  onChange={(e) => setNueva(e.target.value)} autoComplete="new-password" required disabled={busy} />
              </div>
              <div className="mb-2">
                <label className="form-label" htmlFor="confirmarInput">Confirmar contraseña nueva</label>
                <input id="confirmarInput" type={tipo} className="form-control" value={confirmar}
                  onChange={(e) => setConfirmar(e.target.value)} autoComplete="new-password" required disabled={busy} />
              </div>

              <div className="remember-row">
                <div className="form-check m-0">
                  <input id="mostrarPass" className="form-check-input" type="checkbox" checked={mostrar}
                    onChange={(e) => setMostrar(e.target.checked)} disabled={busy} />
                  <label className="form-check-label" htmlFor="mostrarPass">Mostrar contraseñas</label>
                </div>
              </div>

              <button className="btn btn-primary w-100" disabled={busy}>
                {busy ? 'Guardando…' : 'Cambiar contraseña'}
              </button>
              <button type="button" className="btn btn-link w-100 mt-2" onClick={salir} disabled={busy}>Cerrar sesión</button>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}
